module.exports = __webpack_public_path__ + "static/media/values_480.b6fa0c11.png";